import { formatVerifiedDate } from "@/lib/brandHours";

// A stamp/seal that looks like a physical ink impression. The one place the
// site gets visual character.
export default function VerificationSeal({ date, className = "" }) {
  return (
    <div
      data-testid="verification-seal"
      className={`inline-flex select-none animate-seal-in ${className}`}
      style={{ transform: "rotate(-3deg)" }}
    >
      <div className="relative flex flex-col items-center justify-center border-[3px] border-accent px-5 py-3 text-accent">
        <span className="pointer-events-none absolute inset-[3px] border border-dashed border-accent/60" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.3em]">
          Verified
        </span>
        <span className="font-serif text-xl font-semibold leading-none">
          {formatVerifiedDate(date)}
        </span>
        <span className="font-mono text-[9px] font-medium uppercase tracking-[0.2em] text-accent/80">
          Official source
        </span>
      </div>
    </div>
  );
}
